// clay-videos.js
(function () {
  function init() {
    const player = document.querySelector('.clay-videos__player');
    if (!player) return;

    const video  = player.querySelector('.clay-videos__video');
    const cover  = player.querySelector('.clay-videos__cover');
    if (!video) return;

    // Play/pause on click
    player.addEventListener('click', function () {
      if (video.paused) video.play();
      else video.pause();
    });

    // Hide cover when video starts playing
    video.addEventListener('playing', function () {
      if (cover) cover.classList.add('is-hidden');
    });

    // Show cover when paused
    video.addEventListener('pause', function () {
      if (cover) cover.classList.remove('is-hidden');
    });

    // Auto play/pause based on visibility
    new IntersectionObserver(function([entry]) {
      if (entry.isIntersecting) video.play();
      else video.pause();
    }, { threshold: 0.3 }).observe(player);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else setTimeout(init, 0);
})();
